<template>
  <div>
    <section class="xs-banner service-banner contet-to-center">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 col-md-5 align-self-center">
            <div class="xs-banner-content">
              <ul class="breadcrumbs list-inline wow fadeInLeft" data-wow-duration="2s">
                <li><a href="https://episcloud.com">Trang chủ</a></li>
                <li>Chính sách bảo mật</li>
              </ul>
              <p class="wow fadeInUp" data-wow-duration="1.5s"></p>
            </div><!-- .xs-banner-content END -->
          </div>
          <div class="col-lg-6 col-md-7">
            <div class="inner-welcome-image-group">
              <img src="../assets/images/blog.png" alt="Welcome banner image">
              <img src="../assets/images/info-1.png" class="banner-ico banner-ico-1"
                   alt="banner icon"><img src="../assets/images/board.png"
                                          class="banner-ico banner-ico-2" alt="banner icon"></div>
          </div>
        </div><!-- .row END -->
      </div><!-- .container END -->
    </section>
    <div class="page" role="main">
      <div class="builder-content">
        <!-- full-width-content -->
        <div id="post-30" class="full-width-content post-30 page type-page status-publish hentry">
          <div data-elementor-type="wp-post" data-elementor-id="30" class="elementor elementor-30"
               data-elementor-settings="[]">
            <div class="elementor-inner">
              <div class="elementor-section-wrap">
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-9af42a3 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="9af42a3" data-element_type="section">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-c5674a6"
                        data-id="c5674a6" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-e00349e elementor-widget elementor-widget-xs-heading"
                              data-id="e00349e" data-element_type="widget" data-widget_type="xs-heading.default">
                              <div class="elementor-widget-container">
                                <div class="xs-heading">
                                  <h3 class="heading-sub-title">Các điều khoản của chúng tôi</h3>
                                  <h2 class="heading-title">CÁC ĐIỀU KHOẢN <span>RIÊNG TƯ</span></h2>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-7337b23 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="7337b23" data-element_type="section">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-8cb6da2"
                        data-id="8cb6da2" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-77c09c1 elementor-widget elementor-widget-heading"
                              data-id="77c09c1" data-element_type="widget" data-widget_type="heading.default">
                              <div class="elementor-widget-container">
                                <h2 class="elementor-heading-title elementor-size-default">Mục đích và phạm vi thu thập thông tin</h2>
                              </div>
                            </div>
                            <div
                              class="elementor-element elementor-element-8e22874 elementor-widget elementor-widget-text-editor"
                              data-id="8e22874" data-element_type="widget" data-widget_type="text-editor.default">
                              <div class="elementor-widget-container">
                                <div class="elementor-text-editor elementor-clearfix">
                                  <p>EPIS Cloud Việt Nam (sau đây gọi là “EPIS Cloud”) sẽ thu thập các thông tin cá nhân cần thiết của khách hàng như Họ Tên, địa chỉ thư điện tử, số điện thoại, địa chỉ thanh toán để EPIS Cloud  cung cấp dịch vụ, xác thực và quản lý dịch vụ dựa theo thông tin của khách hàng</p>
                                </div>
                              </div>
                            </div>
                            <div
                              class="elementor-element elementor-element-920edc0 elementor-widget elementor-widget-heading"
                              data-id="920edc0" data-element_type="widget" data-widget_type="heading.default">
                              <div class="elementor-widget-container">
                                <h2 class="elementor-heading-title elementor-size-default">Cam kết và Phạm vi sử dụng thông tin</h2></div>
                            </div>
                            <div
                              class="elementor-element elementor-element-21207c5 elementor-widget elementor-widget-text-editor"
                              data-id="21207c5" data-element_type="widget" data-widget_type="text-editor.default">
                              <div class="elementor-widget-container">
                                <div class="elementor-text-editor elementor-clearfix">
                                  <p>
                                    EPIS Cloud cam kết chỉ sử dụng thông tin cá nhân của khách hàng trong phạm vi nội bộ EPIS Cloud và các dữ liệu thông tin cá nhân của khách hàng đều được mã hóa dữ liệu.
                                  </p>
                                  <p>
                                    Trong trường hợp cần thiết, EPIS Cloud sẽ sử dụng các thông tin này để gửi thông báo khuyến mãi, cảm ơn, các thông báo khẩn cấp thông qua email, điện thoại hoặc thư tín.
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div
                              class="elementor-element elementor-element-920edc0 elementor-widget elementor-widget-heading"
                              data-id="920edc0" data-element_type="widget" data-widget_type="heading.default">
                              <div class="elementor-widget-container">
                                <h2 class="elementor-heading-title elementor-size-default">Bảo mật dữ liệu trên máy chủ</h2></div>
                            </div>
                            <div
                              class="elementor-element elementor-element-21207c5 elementor-widget elementor-widget-text-editor"
                              data-id="21207c5" data-element_type="widget" data-widget_type="text-editor.default">
                              <div class="elementor-widget-container">
                                <div class="elementor-text-editor elementor-clearfix">
                                  <p>
                                    Khi khách hàng sử dụng các dịch vụ lưu trữ dữ liệu lên máy chủ tại EPIS Cloud bao gồm Hosting, VPS, máy chủ riêng, Wordpress và các dịch vụ do EPIS Cloud cung cấp . EPIS Cloud cam kết không can thiệp vào dữ liệu được lưu trên máy chủ của quý khách khi không được sự cho phép.
                                  </p>
                                  <p>
                                    EPIS Cloud cũng không chịu trách nhiệm các mất mát dữ liệu liên quan đến sự quản lý không cẩn thận của khách hàng  hay xóa nhầm của khách hàng.
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div
                              class="elementor-element elementor-element-920edc0 elementor-widget elementor-widget-heading"
                              data-id="920edc0" data-element_type="widget" data-widget_type="heading.default">
                              <div class="elementor-widget-container">
                                <h2 class="elementor-heading-title elementor-size-default">Thời gian lưu trữ thông tin</h2></div>
                            </div>
                            <div
                              class="elementor-element elementor-element-21207c5 elementor-widget elementor-widget-text-editor"
                              data-id="21207c5" data-element_type="widget" data-widget_type="text-editor.default">
                              <div class="elementor-widget-container">
                                <div class="elementor-text-editor elementor-clearfix">
                                  <p>
                                    Đối với thông tin cá nhân, EPIS Cloud chỉ xóa đi dữ liệu này nếu khách hàng có yêu cầu, khách hàng yêu cầu gửi mail về  account@episcloud.com
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div
                              class="elementor-element elementor-element-920edc0 elementor-widget elementor-widget-heading"
                              data-id="920edc0" data-element_type="widget" data-widget_type="heading.default">
                              <div class="elementor-widget-container">
                                <h2 class="elementor-heading-title elementor-size-default">Chỉnh sửa thông tin cá nhân</h2></div>
                            </div>
                            <div
                              class="elementor-element elementor-element-21207c5 elementor-widget elementor-widget-text-editor"
                              data-id="21207c5" data-element_type="widget" data-widget_type="text-editor.default">
                              <div class="elementor-widget-container">
                                <div class="elementor-text-editor elementor-clearfix">
                                  <p>
                                    Khách hàng có thể tự chỉnh sửa thông tin cá nhân của mình tại trang quản trị dịch vụ tại EPIS Cloud là https://dash.episcloud.com hoặc gửi yêu cầu vào hộp thư hỗ trợ support@episcloud.com
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div
                              class="elementor-element elementor-element-920edc0 elementor-widget elementor-widget-heading"
                              data-id="920edc0" data-element_type="widget" data-widget_type="heading.default">
                              <div class="elementor-widget-container">
                                <h2 class="elementor-heading-title elementor-size-default">Trách nhiệm của khách hàng</h2></div>
                            </div>
                            <div
                              class="elementor-element elementor-element-21207c5 elementor-widget elementor-widget-text-editor"
                              data-id="21207c5" data-element_type="widget" data-widget_type="text-editor.default">
                              <div class="elementor-widget-container">
                                <div class="elementor-text-editor elementor-clearfix">
                                  <p>
                                    Khách hàng có trách nhiệm khai báo thông tin đầy đủ và chính xác khi đăng ký dịch vụ sử dụng dịch vụ tại EPIS Cloud . Khách hàng tự đặt mật khẩu cho tài khoản đăng nhập của mình và có trách nhiệm tự bảo mật thông tin đăng nhập ( EPIS Cloud sẽ có tránh nhiệm khóa tài khoản nếu phát hiện ra hành vi bất thường xảy ra ở tài khoản khách hàng) .
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-08593eb elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="08593eb" data-element_type="section"
                  data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-6e33099 animated-slow animated fadeInLeft"
                        data-id="6e33099" data-element_type="column"
                        data-settings="{&quot;animation&quot;:&quot;fadeInLeft&quot;}">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-eca8eaa elementor-widget elementor-widget-xs-call-to-action-box"
                              data-id="eca8eaa" data-element_type="widget"
                              data-widget_type="xs-call-to-action-box.default">
                              <div class="elementor-widget-container">
                                <div class="xs-feature-group">
                                  <div class="media">
                                    <div class="feature-img d-flex">
                                      <img width="122" height="138"
                                           src="../assets/images/sheild-2.png"
                                           class="attachment-full size-full" alt="" loading="lazy" draggable="false">
                                    </div>
                                    <div class="media-body feature-content">
                                      <h4 class="xs-title">Days money back guarantee</h4>
                                      <p>Share processes an data secure lona need to know basis without the need.</p>
                                      <div class="xs-btn-wraper">
                                        <a href="#" class="btn btn-secondary">Know More</a>
                                      </div>
                                    </div>
                                  </div>
                                  <span class="icon icon-dollar watermark-icon"></span>
                                </div><!-- .xs-feature-group END -->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-b49de96 animated-slow animated fadeInRight"
                        data-id="b49de96" data-element_type="column"
                        data-settings="{&quot;animation&quot;:&quot;fadeInRight&quot;}">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-df6f32d elementor-widget elementor-widget-xs-call-to-action-box"
                              data-id="df6f32d" data-element_type="widget"
                              data-widget_type="xs-call-to-action-box.default">
                              <div class="elementor-widget-container">
                                <div class="xs-feature-group">
                                  <div class="media">
                                    <div class="feature-img d-flex">
                                      <img width="129" height="138"
                                           src="../assets/images/cloud-lock-2.png"
                                           class="attachment-full size-full" alt="" loading="lazy" draggable="false">
                                    </div>
                                    <div class="media-body feature-content">
                                      <h4 class="xs-title">Build and protect your brand</h4>
                                      <p>Share processes an data secure lona need to know basis without the need.</p>
                                      <div class="xs-btn-wraper">
                                        <a href="#" class="btn btn-secondary">Know More</a>
                                      </div>
                                    </div>
                                  </div>
                                  <span class="icon icon-dollar watermark-icon"></span>
                                </div><!-- .xs-feature-group END -->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-568013b elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="568013b" data-element_type="section"
                  data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-82d5282"
                        data-id="82d5282" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-7c339b6 elementor-widget elementor-widget-spacer"
                              data-id="7c339b6" data-element_type="widget" data-widget_type="spacer.default">
                              <div class="elementor-widget-container">
                                <div class="elementor-spacer">
                                  <div class="elementor-spacer-inner"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div> <!-- end full-width-content -->
      </div> <!-- end main-content -->

    </div>
  </div>
</template>

<script>
export default {
  name: 'Privacy'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Privacy.vue